import {DesktopLogo, LogoLink, MobileLogo} from './Logo.styled';
import {useRouter} from "next/router";

interface Iprops {
  className?: string;
}

export const Logo = ({ className }: Iprops) => {
    const router = useRouter();
  return (
      <LogoLink onClick={() => router.push('/')}>
        <DesktopLogo />
        <MobileLogo />
      </LogoLink>
  );
};

export default Logo;
